import { render, staticRenderFns } from "./DashboardMeasures.vue?vue&type=template&id=2c6e9cba"
import script from "./DashboardMeasures.vue?vue&type=script&lang=ts"
export * from "./DashboardMeasures.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports